import { Box, InputAdornment } from '@mui/material';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import zeplinColor from '../../../theme/Color';

export default function CustomSearch({
  setProjects,
  getProjects,
}: {
  setProjects?: React.Dispatch<React.SetStateAction<any[] | undefined>>;
  getProjects?: (text: string) => void;
}) {
  const [searchText, setSearchText] = React.useState('');
  let wait = React.useRef<any>();

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    clearTimeout(wait?.current);
    const value = event.target.value;
    setSearchText(value);
    wait.current = setTimeout(() => getProjects && getProjects(value), 1000);
  };

  return (
    <Box
      sx={{
        '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
      }}
    >
      <TextField
        variant='outlined'
        placeholder='Search'
        value={searchText}
        onChange={handleSearchChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <img
                width={20}
                height={20}
                src={'/assets/search-icon.svg'}
                alt='search-project'
                style={{
                  borderRadius: '14px',
                  objectFit: 'fill',
                  cursor: 'pointer',
                }}
              />
            </InputAdornment>
          ),
          endAdornment: searchText ? (
            <InputAdornment
              position='end'
              onClick={() => {
                getProjects && getProjects('');
                setSearchText('');
              }}
            >
              <img
                width={20}
                height={20}
                src={'/assets/clear-input.svg'}
                alt='clear-input'
                style={{
                  borderRadius: '14px',
                  objectFit: 'fill',
                  cursor: 'pointer',
                }}
              />
            </InputAdornment>
          ) : (
            ''
          ),
          sx: {
            borderRadius: '50px',
            border: `1px solid ${zeplinColor.Neutral6}`,
            height: { xs: '40px', xl: '48px' },
            '&.Mui-focused': { border: `1px solid ${zeplinColor.Neutral6}` },
          },
        }}
        sx={{
          width: '100%',
          height: { xs: '40px', xl: '48px' },
          padding: 0,

          '& .MuiInputBase-input': {
            padding: '12px 12px',
          },
        }}
      />
    </Box>
  );
}
